<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'USERS.TITLE'"> Users </span>

      <div class="page-buttons" fxHide.xs>
        <button
          mat-stroked-button
          matTooltip="{{ 'USERS.CREATE_USER' | translate }}"
          (click)="openEditDialog()"
          [disabled]="!hasCreateUserPermission"
        >
          <i
            matTooltipPosition="left"
            class="angularjs-fuse-icon icon-plus"
            [matTooltip]="'USERS.PERMISSIONS.NO_CREATE' | translate"
            [matTooltipDisabled]="hasCreateUserPermission"
          ></i>
        </button>

        <button
          *ngIf="hasCreateExportPermission"
          mat-stroked-button
          matTooltip="{{ 'USERS.EXPORT_EXCEL' | translate }}"
          (click)="openExportDialog()"
          [disabled]="!totalCount"
        >
          <i class="angularjs-fuse-icon icon-file-excel"></i>
        </button>

        <button
          *ngIf="filtered"
          mat-stroked-button
          matTooltip="{{ 'USERS.FILTER_CLEAR' | translate }}"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'USERS.FILTER.TITLE' | translate }}"
          (click)="toggleFilterUsersSidebar()"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button mat-stroked-button matTooltip="{{ 'USERS.RELOAD' | translate }}" (click)="reload()">
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuUsers">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuUsers>
          <button
            [disabled]="!hasCreateUserPermission"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="openEditDialog()"
          >
            <i class="angularjs-fuse-icon icon-plus mr-4"></i>
            <span [translate]="'USERS.CREATE_USER'">Add</span>
          </button>

          <button
            *ngIf="hasCreateExportPermission"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="openExportDialog()"
            [disabled]="!totalCount"
          >
            <i class="angularjs-fuse-icon icon-file-excel"></i>
            <span>{{ 'USERS.EXPORT_EXCEL' | translate }}</span>
          </button>

          <button *ngIf="filtered" mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="clearFilters()">
            <i class="angularjs-fuse-icon icon-filter-remove mr-4"></i>
            <span [translate]="'USERS.FILTER_CLEAR'">Clear filter</span>
          </button>

          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="toggleFilterUsersSidebar()">
            <i class="angularjs-fuse-icon icon-filter mr-4"></i>
            <span [translate]="'USERS.FILTER.TITLE'">Filter</span>
          </button>

          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload()">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span [translate]="'USERS.RELOAD'">Reload</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="content-card datatable">
      <mat-table #datatable class="datatable__table" [dataSource]="users" fusePerfectScrollbar matSort>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef fxFlex="20" mat-sort-header>
            {{ 'USERS.HEADER.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let user" fxFlex="20" fxFlex.xs="100">
            <div class="user-image">
              <img
                class="avatar"
                [alt]="user.name"
                [src]="user.avatarUrl || 'https://ui-avatars.com/api/?name=' + user.name"
              />
              <span class="status {{ user.archived ? 'red' : 'green' }}"></span>
            </div>

            <span class="limit-cells" [matTooltipShowDelay]="500" [matTooltip]="user.name">
              {{ user.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef fxFlex>
            {{ 'USERS.HEADER.EMAIL' | translate }}
          </mat-header-cell>
          <mat-cell class="vw-80" *matCellDef="let user" fxFlex fxFlex.xs="100">
            <span class="mobile-label">{{ 'USERS.HEADER.EMAIL' | translate }}:</span>
            <span class="limit-cells" [matTooltipShowDelay]="500" [matTooltip]="user.email">
              {{ user.email }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef fxFlex="12" mat-sort-header>
            {{ 'USERS.HEADER.TYPE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let user" fxFlex="12" fxFlex.xs="100">
            <span class="mobile-label">{{ 'USERS.HEADER.TYPE' | translate }}:</span>

            <span
              *ngIf="user.type === 'all'"
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="'USERS.USER_TYPE.ADMIN' | translate"
            >
              {{ 'USERS.USER_TYPE.ADMIN' | translate }}
            </span>

            <span
              *ngIf="user.type === 'admin'"
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="'USERS.USER_TYPE.MANAGER' | translate"
            >
              {{ 'USERS.USER_TYPE.MANAGER' | translate }}
            </span>

            <span
              *ngIf="user.type === 'requester'"
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="'USERS.USER_TYPE.REQUESTER' | translate"
            >
              {{ 'USERS.USER_TYPE.REQUESTER' | translate }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mfaEnabled">
          <mat-header-cell *matHeaderCellDef fxFlex="10" fxHide.xs>
            {{ 'USERS.HEADER.MFA_ENABLED' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let user" fxFlex="10" fxHide.xs>
            <mat-icon
              class="users-mfa-column"
              [class.users-mfa-column--enabled]="user.mfaEnabled || user.loginIntegrationEnabled"
              [class.users-mfa-column--disabled]="!user.mfaEnabled && !user.loginIntegrationEnabled"
            >
              {{ user.mfaEnabled || user.loginIntegrationEnabled ? 'check_circle' : 'cancel' }}
            </mat-icon>
            <span class="limit-cells">
              <ng-container *ngIf="user.mfaEnabled && !user.loginIntegrationEnabled">
                {{ 'USERS.MFA_ENABLED.ENABLED' | translate }}
              </ng-container>
              <ng-container *ngIf="!user.mfaEnabled && !user.loginIntegrationEnabled">
                {{ 'USERS.MFA_ENABLED.DISABLED' | translate }}
              </ng-container>
              <ng-container *ngIf="user.loginIntegrationEnabled">
                {{ 'USERS.MFA_ENABLED.INTEGRATION' | translate }}
              </ng-container>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="loginProvider">
          <mat-header-cell *matHeaderCellDef fxFlex="10" fxHide.xs>
            {{ 'USERS.HEADER.LOGIN_PROVIDER' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let user" fxFlex="10" fxHide.xs>
            <span class="limit-cells">
              <ng-container *ngIf="user.loginProvider === 'email-password'">
                {{ 'USERS.LOGIN_PROVIDER.EMAIL_AND_PASSWORD' | translate }}
              </ng-container>
              <ng-container *ngIf="user.loginProvider === 'google'">
                {{ 'USERS.LOGIN_PROVIDER.GOOGLE' | translate }}
              </ng-container>
              <ng-container *ngIf="user.loginProvider === 'active-directory'">
                {{ 'USERS.LOGIN_PROVIDER.ACTIVE_DIRECTORY' | translate }}
              </ng-container>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef fxFlex="10" mat-sort-header fxHide.xs>
            {{ 'USERS.HEADER.CREATED_AT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let user" fxFlex="10" fxHide.xs>
            <span
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="user.createdAt | date: 'dd/MM/yyyy HH:mm'"
            >
              {{ user.createdAt | date: 'dd/MM/yyyy HH:mm' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastLoginAt">
          <mat-header-cell *matHeaderCellDef fxFlex="10" mat-sort-header fxHide.xs>
            {{ 'USERS.HEADER.LAST_LOGIN_AT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let user" fxFlex="10" fxHide.xs>
            <span
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltipDisabled]="!user.lastLoginAt"
              [matTooltip]="user.lastLoginAt | date: 'dd/MM/yyyy HH:mm'"
            >
              {{ user.lastLoginAt ? (user.lastLoginAt | date: 'dd/MM/yyyy HH:mm') : '-' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef fxFlex="7">
            {{ 'USERS.HEADER.ACTIONS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let user" fxFlex="7" fxFlex.xs="100">
            <div class="flex-center">
              <div class="flex-start">
                <span class="uppercase bold m-auto" fxHide fxShow.xs>{{ 'USERS.EDIT' | translate }}</span>
                <button
                  mat-icon-button
                  (click)="openEditDialog(user.id)"
                  [matTooltip]="(hasEditUserPermission ? 'USERS.EDIT' : 'USERS.VIEW') | translate"
                  *ngIf="hasEditUserPermission"
                >
                  <img src="assets/images/icons/new_icon_edit_action.svg" alt="edit or view user" />
                </button>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            {{ 'USERS.NO_DATA' | translate }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="loading">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
              <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
              {{ 'USERS.LOADING' | translate }}
            </div>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [hidden]="loading || users?.length"></mat-footer-row>
        <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading || users?.length"></mat-footer-row>
      </mat-table>
      <mat-paginator [length]="totalCount" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
    </div>
  </div>
</div>

<fuse-sidebar name="filterUsers" key="filterUsers" position="right" lockedOpen="true">
  <filter-users class="sidebar-filter"></filter-users>
</fuse-sidebar>
